import React, { Component } from "react"

import Load from "../assets/images/load.png"
import { navigate } from "gatsby"

class Form extends Component {
  state = {
    form: {},
  }

  constructor(props) {
    super(props)
    this.form = React.createRef()
  }

  handleChange = (e) => {
    let { form } = this.state
    if (e.target.name === "type") {
      let current = form[e.target.name] || ""
      if (current.indexOf(e.target.value) === -1) {
        // add
        form[e.target.name] = current + " " + e.target.value
      } else {
        // remove
        form[e.target.name] = current.replace(" " + e.target.value, "")
      }
    } else {
      form[e.target.name] = e.target.value
    }
    this.setState({ form })
  }

  handleSubmit = async (e) => {
    e.preventDefault()

    if (!this.form.current.checkValidity()) return false

    const formData = new FormData(this.form.current)
    formData.append("form-name", this.form.current.getAttribute("name"))
    const queryString = new URLSearchParams(formData).toString()

    // TODO: unused when made so using advocacy_download webhook
    // https://zapier.com/editor/204395603/published/204395604/sample
    await fetch(
      "https://hooks.zapier.com/hooks/catch/2181815/39qnwwf/?" + queryString
    )

    this.setState({ result: "success" })
  }

  render() {
    const data = this.props

    let props = {
      ref: "form",
      name: "advocacy_full_list",
      onSubmit: this.handleSubmit,
    }

    if (this.state.result === "success") {
      navigate("/thank-you-advocacy")
      return (
        <div className="signup__nav">
          <p>
            Thanks for your interest.
            <br /> Download full list{" "}
            <a
              href={data.download}
              target="_blank"
              rel="noopener noreferrer"
              download
            >
              here
            </a>
          </p>
        </div>
      )
    }

    return (
      <div className="signup__nav">
        <form {...props}>
          <p className="title">Looking for a buyer?</p>
          <p>
            If you’ve got the home, we’ve got the buyer. Get in touch to discuss
            a potential sale of your property or listing. Naturally, all
            conversations are confidential.
          </p>
          <div className="form__row form__row--double">
            <input
              type="text"
              className="first_name"
              name="fname"
              placeholder="First Name"
              onChange={this.handleChange}
              required
            />
            <input
              type="text"
              className="last_name"
              name="lname"
              placeholder="Last Name"
              onChange={this.handleChange}
              required
            />
          </div>
          <input
            type="email"
            className="email"
            name="email"
            placeholder="Email"
            onChange={this.handleChange}
          />
          <button className="contactbtn btn" type="submit">
            Get The Full List
          </button>
        </form>
      </div>
    )
  }
}

class AdvocacyClients extends Component {
  state = {
    formActive: false,
  }

  render() {
    const { clients, fullList } = this.props
    let { formActive } = this.state
    return (
      <>
        <section className="advocacy-clients">
          <div className="advocacy-clients__table">
            <div className="advocacy-clients__header">
              <span>Client</span>
              <span>Locations</span>
              <span>Price Point</span>
              <span>Notes</span>
            </div>
            {clients &&
              clients.map((el, i) => (
                <div className="advocacy-clients__row" key={i}>
                  <span>{el.name}</span>
                  <span>{el.suburb}</span>
                  <span>{el.price}</span>
                  <span>{el.notes}</span>
                </div>
              ))}
          </div>
        </section>
        <div className={`${formActive ? "signup active" : "signup"}`}>
          <Form download={fullList.localFile.publicURL} />
          <div className="signup__close">
            <button
              className={formActive ? "active" : ""}
              onClick={() => this.setState({ formActive: false })}
            >
              <img src={Load} alt="Close sign up form" />
            </button>
          </div>
        </div>
      </>
    )
  }
}

export default AdvocacyClients
